import type {
  Program,
  ProgramPrimarySubjectOverride,
  ProgramSubject,
} from "@/common/program/types";

function firstEnglishSubject(
  subjects: ProgramPrimarySubjectOverride[] | ProgramSubject[],
) {
  const englishSubject = subjects?.find(
    (subject) => subject.languageCode === "en",
  );
  if (englishSubject) {
    return englishSubject.name ?? "";
  }
  return "";
}

export default function getProgramSubject(program?: Program) {
  if (!program) {
    return "";
  }
  if (
    program.primarySubjectOverride &&
    program.primarySubjectOverride?.length > 0
  ) {
    return firstEnglishSubject(program.primarySubjectOverride);
  }
  if (program.subjects && program.subjects.length > 0) {
    return firstEnglishSubject(program.subjects);
  }
  return program.subjectEn ?? "";
}
